import axiosInstance from "@/boot/axios";

class PermissionsRepository {
    async getAllPermissions() {
        const response = await axiosInstance.get("/v1/permissions/");
        return response.data;
    }
}

export default new PermissionsRepository();
